import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import FourOhFour from '../../components/FourOhFour/FourOhFour';
import SEO from '../../components/SEO/SEO';
import Layout from '../../components/Layout/Layout';

function NotFound({ isLoading = false }) {
  return (
    <Route
      render={({ staticContext }) => {
        // Have to change status for server rendering
        // and the correct response code
        if (staticContext) {
          staticContext.statusCode = 404;
        }

        return (
          <Layout isLoading={isLoading}>
            <SEO title='404' description='Page not found' />
            <FourOhFour />
          </Layout>
        );
      }}
    />
  );
}

NotFound.getInitialProps = async () => {
  if (typeof window !== 'undefined') {
    window.location.reload();
  }
};

NotFound.propTypes = {};

export default NotFound;
